import { DecimalPipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { CachePartidasService } from 'src/app/core/services/cache-partidas-service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { BudgetDetails } from 'src/app/shared/models/detalle-presupuesto';
import { BudgetItem } from 'src/app/shared/models/partida-presupuesto';

@Component({
  selector: 'app-condiciones-apu',
  templateUrl: './condiciones-apu.component.html',
  styleUrls: ['./condiciones-apu.component.css'],
  providers: [DecimalPipe]
})
export class CondicionesApuComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  private route: string;
  private method: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  condicionesApuForm: FormGroup;
  editar: boolean = true;
  listLineItemsBudget: BudgetItem[] = [];
  infoPresupuesto: BudgetDetails;
  applyIvaBudget: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public pBudgetItem: BudgetItem,
    public dialogCondicionesApuRef: MatDialogRef<CondicionesApuComponent>,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
    private cachePartidasService: CachePartidasService,
    private decimalPipe: DecimalPipe,
  ) { }

  ngOnInit() {
    this.infoPresupuesto = this.helperClassService.getData();
    this.cachePartidasService.getAll().subscribe((data: BudgetItem[]) => {
      this.listLineItemsBudget = data;
    });
    this.condicionesApuForm = new FormGroup({
      referencia: new FormControl({ value: '', disabled: true }),
      descripcion: new FormControl({ value: '', disabled: true }),
      prestaciones: new FormControl({ value: '', disabled: true }),
      administracion: new FormControl({ value: '', disabled: true }),
      utilidad: new FormControl({ value: '', disabled: true }),
      financiamiento: new FormControl({ value: '', disabled: true }),
      iva: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.pattern(Constanst.REGEXP_NUMBERS)]),
      otrosImp: new FormControl({ value: '', disabled: true }),
    });
    this.applyIvaBudget = (this.infoPresupuesto.applyIva == Constanst.APLICAR_IVA_PRESUPUESTO ? true : false);
    this.getconditionsApu();
  }

  getconditionsApu() {
    this.apiCallService.showSpinner();
    this.condicionesApuForm = new FormGroup({
      referencia: new FormControl({ value: '000001', disabled: true }, [Validators.required]),
      descripcion: new FormControl({ value: 'CONDICIONES PREDETERMINADAS', disabled: true }, [Validators.required]),
      prestaciones: new FormControl({ value: this.pBudgetItem.benefit, disabled: true }, [Validators.required, Validators.pattern(Constanst.REGEXP_NUMBERS)]),
      administracion: new FormControl({ value: this.pBudgetItem.administrativeExpense, disabled: true }, [Validators.required, Validators.pattern(Constanst.REGEXP_NUMBERS)]),
      utilidad: new FormControl({ value: this.pBudgetItem.unexpectedUtility, disabled: true }, [Validators.required, Validators.pattern(Constanst.REGEXP_NUMBERS)]),
      financiamiento: new FormControl({ value: this.pBudgetItem.financing, disabled: true }, [Validators.required, Validators.pattern(Constanst.REGEXP_NUMBERS)]),
      iva: new FormControl({ value: this.pBudgetItem.iva, disabled: true }, [Validators.required, Validators.pattern(Constanst.REGEXP_NUMBERS), Validators.minLength(1), Validators.maxLength(2)]),
      otrosImp: new FormControl({ value: this.pBudgetItem.otherTax, disabled: true }, [Validators.required, Validators.pattern(Constanst.REGEXP_NUMBERS)])
    });
    this.apiCallService.hideSpinner();
  }

  onSubmit(): void {
    if (this.condicionesApuForm.invalid) {
      return;
    } else {
      if (this.applyIvaBudget) {
        this.cachePartidasService.modifyOnBudget(Constanst.CACHE_NAME_BUDGET_IVA, Number(this.condicionesApuForm.controls['iva'].value));
        this.cachePartidasService.modifyOnBudget(Constanst.CACHE_NAME_BUDGET_OTHERTAX, Number(this.condicionesApuForm.controls['otrosImp'].value));
        this.helperClassService.notifierNewChangeBudget.emit(Constanst.CACHE_NAME_BUDGET_IVA);
        return this.modificarCondicionesAllApu();
      } else {
        return this.modificarCondicionesApu();
      }
    }
  }

  modificarCondicionesApu() {
    this.route = '/updateApuConditionByBudgetLineItem';
    this.method = 'POST';

    let materialPriceReplaceList: any[] = [];
    this.cachePartidasService.getOnBudgetById(Constanst.CACHE_MATERIAL_PRICE_REPLACE).subscribe((materialPriceReplace: any) => {
      materialPriceReplaceList = (materialPriceReplace !== undefined && materialPriceReplace.length > 0 ? materialPriceReplace : []);
    });
    let equipmentPriceReplaceList: any[] = [];
    this.cachePartidasService.getOnBudgetById(Constanst.CACHE_EQUIPMENT_PRICE_REPLACE).subscribe((equipmentPriceReplace: any) => {
      equipmentPriceReplaceList = (equipmentPriceReplace !== undefined && equipmentPriceReplace.length > 0 ? equipmentPriceReplace : []);
    });
    let laborPriceReplaceList: any[] = [];
    this.cachePartidasService.getOnBudgetById(Constanst.CACHE_LABOR_PRICE_REPLACE).subscribe((laborPriceReplace: any) => {
      laborPriceReplaceList = (laborPriceReplace !== undefined && laborPriceReplace.length > 0 ? laborPriceReplace : []);
    });

    let data = {
      idBudget: this.infoPresupuesto.budgetId,
      idLineItem: this.pBudgetItem.idLineItem,
      idLineItemUser: (this.pBudgetItem.idLineItemUser == 0 ? null : this.pBudgetItem.idLineItemUser),
      apuConditionTo: {
        benefit: Number(this.condicionesApuForm.controls['prestaciones'].value).toFixed(2),
        administrativeExpense: Number(this.condicionesApuForm.controls['administracion'].value).toFixed(2),
        unexpectedUtility: Number(this.condicionesApuForm.controls['utilidad'].value).toFixed(2),
        financing: Number(this.condicionesApuForm.controls['financiamiento'].value).toFixed(2),
        iva: Number(this.condicionesApuForm.controls['iva'].value).toFixed(2),
        otherTax: Number(this.condicionesApuForm.controls['otrosImp'].value).toFixed(2)
      },
      materialPrice: materialPriceReplaceList,
      equipmentPrice: equipmentPriceReplaceList,
      laborPrice: laborPriceReplaceList
    };

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
          this.apiCallService.hideSpinner();
          let dialogUpdate = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONDITIONAPU_UPDATED, false, true, false, '', '', '', Constanst.DIALOG_RESULT_SUCCESS);
          dialogUpdate.afterClosed().subscribe((result: string) => {

            this.pBudgetItem.benefit = Number(data.apuConditionTo.benefit);
            this.pBudgetItem.administrativeExpense = Number(data.apuConditionTo.administrativeExpense);
            this.pBudgetItem.unexpectedUtility = Number(data.apuConditionTo.unexpectedUtility);
            this.pBudgetItem.financing = Number(data.apuConditionTo.financing);
            this.pBudgetItem.iva = Number(data.apuConditionTo.iva);
            this.pBudgetItem.otherTax = Number(data.apuConditionTo.otherTax);
            this.pBudgetItem.unitPrice = response.data;
            this.pBudgetItem.assumedPrice = response.data;
            this.pBudgetItem.total = (this.pBudgetItem.unitPrice * this.pBudgetItem.quantity);
            this.cachePartidasService.modify(this.pBudgetItem.idLineItem.toString(), this.pBudgetItem);
            this.helperClassService.notifierNewChangeBudget.emit('apuCondition');

            this.closeDialogCondicionesApu();
          });
        } else {
          this.apiCallService.hideSpinner();
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
        }
      });
  }

  onSubmitAll(): void {
    if (this.condicionesApuForm.invalid) {
      return;
    } else {
      return this.modificarCondicionesAllApu();
    }
  }

  modificarCondicionesAllApu() {
    let materialPriceReplaceList: any[] = [];
    this.cachePartidasService.getOnBudgetById(Constanst.CACHE_MATERIAL_PRICE_REPLACE).subscribe((materialPriceReplace: any) => {
      materialPriceReplaceList = (materialPriceReplace !== undefined && materialPriceReplace.length > 0 ? materialPriceReplace : []);
    });
    let equipmentPriceReplaceList: any[] = [];
    this.cachePartidasService.getOnBudgetById(Constanst.CACHE_EQUIPMENT_PRICE_REPLACE).subscribe((equipmentPriceReplace: any) => {
      equipmentPriceReplaceList = (equipmentPriceReplace !== undefined && equipmentPriceReplace.length > 0 ? equipmentPriceReplace : []);
    });
    let laborPriceReplaceList: any[] = [];
    this.cachePartidasService.getOnBudgetById(Constanst.CACHE_LABOR_PRICE_REPLACE).subscribe((laborPriceReplace: any) => {
      laborPriceReplaceList = (laborPriceReplace !== undefined && laborPriceReplace.length > 0 ? laborPriceReplace : []);
    });

    for (let i = 0; i < this.listLineItemsBudget.length; i++) {
      let partida = this.listLineItemsBudget[i];
      this.route = '/updateApuConditionByBudgetLineItem';
      this.method = 'POST';
      let data = {
        idBudget: this.infoPresupuesto.budgetId,
        idLineItem: partida.idLineItem,
        idLineItemUser: (partida.idLineItemUser == 0 ? null : partida.idLineItemUser),
        apuConditionTo: {
          benefit: Number(this.condicionesApuForm.controls['prestaciones'].value).toFixed(2),
          administrativeExpense: Number(this.condicionesApuForm.controls['administracion'].value).toFixed(2),
          unexpectedUtility: Number(this.condicionesApuForm.controls['utilidad'].value).toFixed(2),
          financing: Number(this.condicionesApuForm.controls['financiamiento'].value).toFixed(2),
          iva: Number(this.condicionesApuForm.controls['iva'].value).toFixed(2),
          otherTax: Number(this.condicionesApuForm.controls['otrosImp'].value).toFixed(2)
        },
        materialPrice: materialPriceReplaceList,
        equipmentPrice: equipmentPriceReplaceList,
        laborPrice: laborPriceReplaceList
      };

      this.apiCallService.call$(data, this.route, this.method, true, '', true)
        .pipe(takeUntil(this.destroy$)).subscribe(response => {

          if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
            partida.benefit = Number(data.apuConditionTo.benefit);
            partida.administrativeExpense = Number(data.apuConditionTo.administrativeExpense);
            partida.unexpectedUtility = Number(data.apuConditionTo.unexpectedUtility);
            partida.financing = Number(data.apuConditionTo.financing);
            partida.iva = Number(data.apuConditionTo.iva);
            partida.otherTax = Number(data.apuConditionTo.otherTax);
            partida.unitPrice = response.data;
            partida.assumedPrice = response.data;
            partida.total = (partida.unitPrice * partida.quantity);
            this.cachePartidasService.modify(partida.idLineItem.toString(), partida);
          }

          if ((i + 1) == this.listLineItemsBudget.length) {
            this.apiCallService.hideSpinner();
            let dialogUpdate = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONDITIONAPU_UPDATED, false, true, false, '', '', '', Constanst.DIALOG_RESULT_SUCCESS);
            dialogUpdate.afterClosed().subscribe((result: string) => {
              this.helperClassService.notifierNewChangeBudget.emit('apuCondition');
              this.closeDialogCondicionesApu();
            });
          }
        });
    }
  }

  habilitarCampos() {
    this.condicionesApuForm.get('prestaciones')?.enable();
    this.condicionesApuForm.get('administracion')?.enable();
    this.condicionesApuForm.get('utilidad')?.enable();
    this.condicionesApuForm.get('financiamiento')?.enable();
    this.condicionesApuForm.get('iva')?.enable();
    this.condicionesApuForm.get('otrosImp')?.enable();
    this.editar = false;
  }

  closeDialogCondicionesApu() {
    this.dialogCondicionesApuRef.close();
  }

}
